import { render, staticRenderFns } from "./RolesDatatable.vue?vue&type=template&id=5e3279da"
import script from "./RolesDatatable.vue?vue&type=script&lang=js"
export * from "./RolesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports